module.exports = __webpack_public_path__ + "cfef3b157209cc03b08889ccb0f0bf44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/1.jpg
// module id = 1335
// module chunks = 47